import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import Budget from "./Budget";

const BudgetWrapper: React.FC = () => {
    const budget = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.signUpPageData?.fields?.budget,
    );

    return useMemo(() => {
        if (budget) {
            return (
                <FieldWrapper visible={budget.visible} loading={budget.loading ?? false}>
                    <Budget
                        fieldName={budget.fieldName}
                        values={budget.values}
                        selectedValue={budget.selectedValue}
                        editable={budget.editable}
                    />
                </FieldWrapper>
            );
        }
        return null;
    }, [budget]);
};
export default BudgetWrapper;
